import React from "react";
import { Title } from "../../components/Title";
import { CardOne } from "../../components/Card/CardOne";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const DeveloperUse = () => {
  const { t } = useTranslation();
  const cards = [
    {
      icon: "icon authing-icon authing-zhuce icon-style",
      title: `${t("developer.use.item-one.title")}`,
      subtitle: `${t("developer.use.item-one.subtitle")}`,
      links: [
        {
          text: `${t("developer.use.item-one.list-one")}`,
          adress: "https://docs.authing.cn/v2/concepts/user-pool.html",
        },
        {
          text: `${t("developer.use.item-one.list-two")}`,
          adress: "https://docs.authing.cn/v2/guides/basics/console/",
        },
      ],
      adress: "https://authing.cn/login",
      button: `${t("developer.button.quickLogin")}`,
    },
    {
      icon: "icon authing-icon authing-kaifawendang icon-style",
      title: `${t("developer.use.item-two.title")}`,
      subtitle: `${t("developer.use.item-two.subtitle")}`,
      links: [{ text: `${t("developer.use.item-two.list-one")}`, adress: "https://github.com/Authing/AuthingSSO" }],
      adress: "https://github.com/Authing/web-sso-sample",
      button: `${t("developer.button.learn-more")}`,
    },
    {
      icon: "icon authing-icon authing-kuaisukaishi icon-style",
      title: `${t("developer.use.item-three.title")}`,
      subtitle: `${t("developer.use.item-three.subtitle")}`,
      links: [
        {
          text: `${t("developer.use.item-three.list-one")}`,
          adress: "https://docs.authing.cn/v2/concepts/",
        },
        {
          text: `${t("developer.use.item-three.list-two")}`,
          adress:
            "https://docs.authing.cn/v2/concepts/#%E4%B8%BA%E4%BB%80%E4%B9%88%E8%A6%81%E4%BD%BF%E7%94%A8-localeconfig-brandname",
        },
      ],
      adress: "https://docs.authing.cn/v2",
      button: `${t("developer.button.learn-more")}`,
    },
  ];
  const enterPage = (adress) => {
    window.open(adress);
  };
  return (
    <div>
      <section className="developer-use" id="use">
        <div className="inner">
          <Title title={t("developer.use.title")}></Title>
          <div className="developer-content">
            {cards.map((item) => {
              return (
                <CardOne
                  icon={<i className={item.icon}></i>}
                  title={item.title}
                  subtitle={item.subtitle}
                  links={item.links}
                  aside={
                    <div
                      onClick={() => {
                        enterPage(item.adress);
                      }}
                    >
                      <div className="developer-use-button">{item.button}</div>
                    </div>
                  }
                />
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
